import React from "react"
import { Round } from "./types"

// Network destinations are supplied only by authenticated scoring responses.
export default function NetworkLeaderboardTabs({ round, children }: { round: Round; children: React.ReactNode }) {
  return (
    <div className="network-competition" data-controller={round.networkRound ? "network-competition" : undefined}>
      {round.networkRound && (
        <div className="spark-tab-bar">
          <div className="inner">
            <a
              className="active"
              href={`/app/league_rounds/${round.id}`}
              data-network-competition-target="localLink"
              data-action="network-competition#showLocal"
            >
              {round.league.courseShortLabel}
            </a>
            <a
              href={`/app/nr/${round.networkRound.sqid}?league_id=${round.league.id}`}
              data-network-competition-target="networkLink"
              data-action="network-competition#showNetwork"
            >
              All {round.networkRound.name}
            </a>
          </div>
        </div>
      )}
      <div data-network-competition-target="local">{children}</div>
      {round.networkRound && (
        <div data-network-competition-target="network" hidden style={{ display: "none" }}>
          {React.createElement(
            "turbo-frame",
            {
              id: `network-leaderboard-${round.networkRound.sqid}`,
              "data-src": `/app/nr/${round.networkRound.sqid}?embedded=1&league_id=${round.league.id}`,
              "data-network-competition-target": "frame",
              loading: "lazy",
              "data-turbo": "true"
            },
            <p>Loading leaderboard…</p>
          )}
        </div>
      )}
    </div>
  )
}
